/* GREEN GUAVA — scroll reveal, animated header, mega menu */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Screen-reader status announcements (WCAG 4.1.3) --------------------
  // Writes to the global polite live region so state changes that don't move
  // focus (cart updates, studio/kit feedback) are announced. Re-set the text
  // after a tick so identical consecutive messages still fire.
  var _liveTimer = null;
  function ggAnnounce(msg) {
    var region = document.getElementById('gg-live-region');
    if (!region || !msg) return;
    region.textContent = '';
    if (_liveTimer) clearTimeout(_liveTimer);
    _liveTimer = setTimeout(function () { region.textContent = msg; }, 60);
  }
  window.ggAnnounce = ggAnnounce;

  // ---- Shared modal focus management -------------------------------------
  // Keeps Tab focus inside an open dialog, hides the rest of the page from
  // assistive tech, and restores focus to the trigger on close (WCAG 2.4.3).
  var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function focusableIn(el) {
    return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (n) {
      return n.offsetWidth > 0 || n.offsetHeight > 0 || n === document.activeElement;
    });
  }
  // Mark all page content inert while a dialog is open, so background content
  // is neither focusable nor announced by screen readers. The dialog is often
  // nested deep inside wrapper divs (.gg-shell > .shopify-section > dialog),
  // so we walk from the dialog up to <body> and inert every *sibling* along
  // the ancestor chain — that isolates the dialog no matter how deep it lives.
  // Only elements we touch are marked (data-gg-inerted) so cleanup never
  // clobbers attributes the markup set itself.
  function setBackgroundInert(dialog, on) {
    if (window.Shopify && window.Shopify.designMode) return; // don't fight the theme editor
    var node = dialog;
    while (node && node !== document.body && node.parentElement) {
      Array.prototype.forEach.call(node.parentElement.children, function (sib) {
        if (sib === node) return; // the dialog's own ancestor branch stays interactive
        if (sib.tagName === 'SCRIPT' || sib.tagName === 'STYLE' || sib.tagName === 'LINK') return;
        if (on) {
          if (sib.hasAttribute('data-gg-inerted')) return;
          sib.setAttribute('data-gg-inerted', sib.hasAttribute('aria-hidden') ? 'keep-ah' : '');
          sib.setAttribute('inert', '');
          sib.setAttribute('aria-hidden', 'true');
        } else if (sib.hasAttribute('data-gg-inerted')) {
          sib.removeAttribute('inert');
          if (sib.getAttribute('data-gg-inerted') !== 'keep-ah') sib.removeAttribute('aria-hidden');
          sib.removeAttribute('data-gg-inerted');
        }
      });
      node = node.parentElement;
    }
  }
  // Returns a controller with open()/close() that wraps a dialog element.
  function makeModal(dialog, opts) {
    opts = opts || {};
    var lastFocus = null;
    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      var items = focusableIn(dialog);
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    return {
      activate: function () {
        lastFocus = document.activeElement;
        setBackgroundInert(dialog, true);
        dialog.addEventListener('keydown', onKeydown);
        var target = (opts.initialFocus && dialog.querySelector(opts.initialFocus)) || focusableIn(dialog)[0] || dialog;
        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      },
      deactivate: function () {
        setBackgroundInert(dialog, false);
        dialog.removeEventListener('keydown', onKeydown);
        if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
        lastFocus = null;
      }
    };
  }

  // Auto-tag elements for scroll-reveal so the whole site animates in.
  function autoReveal() {
    if (reduce) return;
    var sel = 'main section, .gg-footer, .gg-cats__grid > *, .gg-grid > *, .gg-whygrid > *, .gg-quotes__grid > *, .gg-statgrid > *, .gg-valuecards > *, .gg-faq__item, .gg-whyrow';
    document.querySelectorAll(sel).forEach(function (el) {
      if (!el.classList.contains('gg-reveal') && !el.hasAttribute('data-gg-no-reveal') && !el.querySelector(':scope > [data-gg-no-reveal]') && !el.closest('.gg-site-header') && !el.closest('.gg-hmega') && !el.closest('.gg-drawer')) {
        el.classList.add('gg-reveal');
      }
    });
    // stagger items inside common grids
    document.querySelectorAll('.gg-grid, .gg-cats__grid, .gg-whygrid, .gg-quotes__grid').forEach(function (grid) {
      var kids = grid.children, i = 0;
      for (; i < kids.length; i++) { if (!kids[i].hasAttribute('data-delay')) kids[i].setAttribute('data-delay', i % 4); }
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.gg-reveal');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    // threshold:0 — reveal as soon as ANY pixel enters (fixes very tall sections
    // that never reach a ratio threshold and would otherwise stay invisible).
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });

    // Safety net: never let content stay hidden. On load/scroll/resize, reveal
    // anything already in (or above) the viewport — guards against the observer
    // missing fast programmatic scrolls or unusual layouts. Self-removes once done.
    var onScroll;
    var sweep = function () {
      var stuck = document.querySelectorAll('.gg-reveal:not(.is-in)');
      if (!stuck.length) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        return;
      }
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < stuck.length; i++) {
        if (stuck[i].getBoundingClientRect().top < vh * 0.96) {
          stuck[i].classList.add('is-in');
          io.unobserve(stuck[i]);
        }
      }
    };
    var ticking = false;
    onScroll = function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { sweep(); ticking = false; });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', sweep);
    setTimeout(sweep, 300);
  }

  // Rich mega menu: hover/focus a left-rail tab to switch panels.
  function initMegaTabs() {
    document.querySelectorAll('.gg-hmega').forEach(function (mega) {
      var tabs = mega.querySelectorAll('.gg-hmega__tab');
      var panels = mega.querySelectorAll('.gg-hmega__panel');
      function activate(i) {
        tabs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        panels.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('mouseenter', function () { activate(i); });
        tab.addEventListener('focus', function () { activate(i); });
        tab.addEventListener('click', function (e) { if (!tab.getAttribute('href')) { e.preventDefault(); activate(i); } });
      });
    });
  }

  // iOS-safe page-scroll lock for overlays: plain overflow:hidden still lets
  // Safari rubber-band the page behind a drawer, so pin the body in place and
  // restore the scroll position (instantly — html has smooth-scroll) on unlock.
  var ggLockY = 0, ggLocked = false;
  function ggLockScroll() {
    if (ggLocked) return; ggLocked = true;
    ggLockY = window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = -ggLockY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%'; b.overflow = 'hidden';
  }
  function ggUnlockScroll() {
    if (!ggLocked) return; ggLocked = false;
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.overflow = '';
    var html = document.documentElement, prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, ggLockY);
    html.style.scrollBehavior = prev;
  }

  // Phone back button/gesture closes an open overlay instead of leaving the
  // page: each open pushes one history entry; popstate closes the overlay;
  // a manual close consumes the entry so history stays balanced.
  var ggOvStack = [], ggOvManual = false;
  function ggOverlayOpened(closeFn) {
    try { history.pushState({ ggOverlay: true }, ''); ggOvStack.push(closeFn); } catch (e) {}
  }
  function ggOverlayClosed() {
    if (!ggOvStack.length) return;
    ggOvStack.pop(); ggOvManual = true;
    try { history.back(); } catch (e) { ggOvManual = false; }
  }
  function ggOverlayAbandon() { ggOvStack.pop(); } // close that navigates away — leave history alone
  window.addEventListener('popstate', function () {
    if (ggOvManual) { ggOvManual = false; return; }
    var fn = ggOvStack.pop();
    if (fn) fn();
  });

  function initDrawer() {
    var toggle = document.getElementById('gg-nav-toggle');
    if (!toggle) return;
    function closeNav() { toggle.checked = false; ggUnlockScroll(); ggOverlayClosed(); }
    // labels (scrim, X, hamburger) fire change; programmatic closes below don't
    toggle.addEventListener('change', function () {
      if (toggle.checked) {
        ggLockScroll();
        ggOverlayOpened(function () { toggle.checked = false; ggUnlockScroll(); });
      } else { ggUnlockScroll(); ggOverlayClosed(); }
    });
    document.querySelectorAll('.gg-drawer a').forEach(function (a) {
      // link click both closes and navigates — don't fight the navigation with history.back()
      a.addEventListener('click', function () { toggle.checked = false; ggUnlockScroll(); ggOverlayAbandon(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && toggle.checked) closeNav(); });
  }

  function initStickyHeader() {
    var header = document.querySelector('.gg-site-header');
    var shell = document.querySelector('.gg-shell');
    if (!header) return;
    var base = parseInt(header.getAttribute('data-shrink-at') || '24', 10);
    // Hysteresis: engage a bit lower than the page top, release higher up,
    // so micro-scrolls near the boundary can't flip the pill state (no jitter).
    var onAt = base + 44;
    var offAt = Math.max(0, base);
    var stuck = false, ticking = false;
    function apply() {
      var y = window.scrollY || window.pageYOffset || 0;
      if (!stuck && y > onAt) stuck = true;
      else if (stuck && y < offAt) stuck = false;
      header.classList.toggle('is-stuck', stuck);
      if (shell) shell.classList.toggle('is-stuck', stuck);
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    apply();
  }

  // Before/after compare slider (drag, touch, arrow keys).
  // Live search suggestions: after 1+ characters, show matching products
  // (predictive API prefix-matches partial words) under the header/drawer search.
  // Prefix-wildcard EVERY typed word: "sal eje" -> "sal* eje*". Shopify's
  // options[prefix]=last only prefix-matches the LAST word, so partial earlier
  // words ("sal eje") returned nothing; per-word "*" fixes multi-word searches
  // for both the live suggestions and the full results page.
  function ggSearchWildcard(q) {
    return String(q).trim().split(/\s+/).filter(Boolean).map(function (w) {
      return w.charAt(w.length - 1) === '*' ? w : w + '*';
    }).join(' ');
  }
  function initSearchSuggest() {
    function escT(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    // On submit, rewrite q to the wildcard form so the results page matches too. Covers
    // the header + drawer search (.gg-search) and the on-page results search (.gg-prodsearch__form).
    document.querySelectorAll('form.gg-search, form.gg-prodsearch__form').forEach(function (f) {
      if (f.dataset.ggWild) return;
      f.dataset.ggWild = '1';
      f.addEventListener('submit', function (e) {
        var inp = f.querySelector('input[name="q"]');
        if (!inp || !inp.value.trim()) return;
        // Navigate manually with the wildcard query so the visible search box
        // never flashes the "*" characters (they exist only for Shopify's matcher).
        e.preventDefault();
        var params = new URLSearchParams(new FormData(f));
        params.set('q', ggSearchWildcard(inp.value));
        window.location.href = (f.getAttribute('action') || '/search') + '?' + params.toString();
      });
    });
    document.querySelectorAll('form.gg-search, form.gg-prodsearch__form').forEach(function (form) {
      var input = form.querySelector('input[type="search"]');
      if (!input || form.dataset.ggSuggest) return;
      form.dataset.ggSuggest = '1';
      var panel = document.createElement('div');
      panel.className = 'gg-suggest';
      panel.hidden = true;
      form.style.position = 'relative';
      form.appendChild(panel);
      var t = null, lastQ = '';
      function close() { panel.hidden = true; panel.innerHTML = ''; lastQ = ''; }
      function rowProduct(p) {
        var src = p.image || '';
        if (src && src.indexOf('width=') === -1) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=72';
        var img = src ? '<img src="' + escT(src) + '" width="36" height="36" loading="lazy" alt="">' : '';
        var priceTxt = p.priceHtml || (p.price ? (window.ggMoney ? ggMoney(Math.round(parseFloat(p.price) * 100)) : 'Rs. ' + p.price) : '');
        var price = priceTxt ? '<em>' + escT(priceTxt) + '</em>' : '';
        return '<a class="gg-suggest__row" href="' + escT(p.url) + '">' + img + '<span>' + escT(p.title) + '</span>' + price + '</a>';
      }
      function rowLink(title, url, label) {
        return '<a class="gg-suggest__row" href="' + escT(url) + '"><span>' + escT(title) + '</span><em>' + label + '</em></a>';
      }
      function renderPanel(products, collections, pages, allHref) {
        var html = (products || []).map(rowProduct).join('');
        if (collections && collections.length) html += '<div class="gg-suggest__grouphd">Categories</div>' + collections.map(function (c) { return rowLink(c.title, c.url, 'Category'); }).join('');
        if (pages && pages.length) html += '<div class="gg-suggest__grouphd">Pages</div>' + pages.map(function (p) { return rowLink(p.title, p.url, 'Page'); }).join('');
        html += '<a class="gg-suggest__all" href="' + allHref + '">See all results &rarr;</a>';
        panel.innerHTML = html; panel.hidden = false;
      }
      // The instant API only reads title/type/vendor — NOT tags, description, or synonyms.
      // The full /search does. So when the instant lookup finds no product, mirror the full
      // search here: that's what makes any keyword you've tagged (e.g. "RVG") appear live.
      function fullSearchFallback(wq) {
        return fetch('/search?q=' + encodeURIComponent(wq) + '&type=product')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return [].slice.call(doc.querySelectorAll('.gg-grid .gg-card')).slice(0, 6).map(function (card) {
              var a = card.querySelector('.gg-card__name') || card.querySelector('a[href*="/products/"]');
              var img = card.querySelector('img');
              var price = card.querySelector('.gg-price__now');
              return {
                title: a ? a.textContent.trim() : '',
                url: a ? a.getAttribute('href') : '',
                image: img ? (img.getAttribute('src') || '') : '',
                priceHtml: price ? price.textContent.trim() : ''
              };
            }).filter(function (p) { return p.url && p.title; });
          }).catch(function () { return []; });
      }
      input.addEventListener('input', function () {
        clearTimeout(t);
        var q = input.value.trim();
        if (!q) { close(); return; }
        if (q === lastQ) return;
        t = setTimeout(function () {
          lastQ = q;
          var wq = ggSearchWildcard(q);
          var allHref = '/search?q=' + encodeURIComponent(wq) + '&type=product&options%5Bprefix%5D=last';
          fetch('/search/suggest.json?q=' + encodeURIComponent(wq) + '&resources[type]=product,collection,page&resources[limit]=6')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (input.value.trim() !== q) return;
              var R = (d.resources && d.resources.results) || {};
              var products = R.products || [];
              var collections = (R.collections || []).slice(0, 3);
              var pages = (R.pages || []).slice(0, 3);
              if (products.length) { renderPanel(products, collections, pages, allHref); return; }
              if (q.length < 2) { renderPanel([], collections, pages, allHref); return; }
              fullSearchFallback(wq).then(function (fp) {
                if (input.value.trim() !== q) return;
                if (fp.length || collections.length || pages.length) {
                  renderPanel(fp, collections, pages, allHref);
                } else {
                  // Both the instant lookup and the full search came back empty, so sending
                  // them to /search would just repeat the same dead end. Offer the catalogue.
                  panel.innerHTML = '<a class="gg-suggest__all" href="/collections/all-products">No matches — browse all products &rarr;</a>';
                  panel.hidden = false;
                }
              });
            }).catch(function () {});
        }, 180);
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      form.addEventListener('submit', function () { close(); });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
  }

  function initCompare() {
    document.querySelectorAll('[data-gg-compare]').forEach(function (el) {
      var dragging = false, samples = [], glideId = 0;
      var reduceM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      function pctNow() { return parseFloat(el.style.getPropertyValue('--gg-split')) || 50; }
      function apply(pct) {
        pct = Math.max(0, Math.min(100, pct));
        el.style.setProperty('--gg-split', pct + '%');
        el.setAttribute('aria-valuenow', Math.round(pct));
        return pct;
      }
      function setSplit(clientX) {
        var r = el.getBoundingClientRect();
        var pct = apply(((clientX - r.left) / r.width) * 100);
        samples.push({ p: pct, t: performance.now() });
        if (samples.length > 6) samples.shift();
      }
      // flick momentum: glide with friction after release, soft rebound at the edges
      function glide() {
        if (samples.length < 2 || reduceM) return;
        var a = samples[0], b = samples[samples.length - 1];
        var dt = b.t - a.t;
        if (dt <= 0 || dt > 220) return;
        var v = (b.p - a.p) / dt; // %/ms
        if (Math.abs(v) < 0.05) return;
        var pct = b.p, last = performance.now();
        cancelAnimationFrame(glideId);
        (function step(now) {
          var d = Math.min(48, now - last); last = now;
          pct += v * d;
          if (pct <= 0 || pct >= 100) { pct = pct <= 0 ? 0 : 100; v = -v * 0.28; } // wall rebound
          v *= Math.pow(0.94, d / 16.7); // friction
          apply(pct);
          if (Math.abs(v) > 0.004 && !dragging) glideId = requestAnimationFrame(step);
        })(last);
      }
      // Window move/up listeners are attached only for the duration of a drag,
      // so the theme isn't holding permanent non-passive touchmove handlers
      // (which block scroll-optimization) for every compare widget on the page.
      function move(e) { if (dragging) setSplit((e.touches ? e.touches[0] : e).clientX); }
      function up() {
        dragging = false;
        window.removeEventListener('mousemove', move);
        window.removeEventListener('touchmove', move, { passive: false });
        window.removeEventListener('mouseup', up);
        window.removeEventListener('touchend', up);
        glide();
      }
      function down(e) {
        dragging = true; cancelAnimationFrame(glideId); samples = [];
        setSplit((e.touches ? e.touches[0] : e).clientX); e.preventDefault();
        window.addEventListener('mousemove', move);
        window.addEventListener('touchmove', move, { passive: false });
        window.addEventListener('mouseup', up);
        window.addEventListener('touchend', up);
      }
      el.addEventListener('mousedown', down);
      el.addEventListener('touchstart', down, { passive: false });
      el.addEventListener('keydown', function (e) {
        var cur = parseFloat(el.getAttribute('aria-valuenow')) || 50;
        if (e.key === 'ArrowLeft') { cur -= 4; }
        else if (e.key === 'ArrowRight') { cur += 4; }
        else return;
        cur = Math.max(0, Math.min(100, cur));
        el.style.setProperty('--gg-split', cur + '%');
        el.setAttribute('aria-valuenow', Math.round(cur));
        e.preventDefault();
      });
    });
  }

  // Hero slider — auto-rotate, dots, arrows, swipe, pause on hover, arrow keys.
  function initHero() {
    document.querySelectorAll('[data-gg-hero]').forEach(function (root) {
      var slides = [].slice.call(root.querySelectorAll('[data-hero-slide]'));
      if (slides.length < 2) return;
      var dots = [].slice.call(root.querySelectorAll('[data-hero-dot]'));
      var interval = parseInt(root.getAttribute('data-interval') || '6000', 10);
      var i = 0, timer = null;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) {
          d.classList.remove('is-active');
          if (k === i) { void d.offsetWidth; d.classList.add('is-active'); } // restart dot fill
        });
      }
      function next() { show(i + 1); }
      function prev() { show(i - 1); }
      var userPaused = false;
      function start() { if (!reduce && !userPaused) { stop(); timer = setInterval(next, interval); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function go(n) { show(n); start(); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var nx = root.querySelector('[data-hero-next]'); if (nx) nx.addEventListener('click', function () { go(i + 1); });
      var pv = root.querySelector('[data-hero-prev]'); if (pv) pv.addEventListener('click', function () { go(i - 1); });
      // no hover-pause: the loop keeps sliding under the cursor. Pausing is an
      // explicit choice via the pause/play control.
      var pp = root.querySelector('[data-hero-pause]');
      function setPaused(paused) {
        userPaused = paused;
        root.classList.toggle('is-paused', paused);
        if (pp) {
          pp.setAttribute('aria-pressed', paused ? 'true' : 'false');
          pp.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
          // icons are inline SVGs toggled by [aria-pressed] CSS
        }
        if (paused) stop(); else start();
      }
      if (pp) {
        if (reduce) pp.style.display = 'none'; // reduced motion: no autoplay to control
        else pp.addEventListener('click', function () { setPaused(!userPaused); });
      }
      // swipe
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { dx < 0 ? go(i + 1) : go(i - 1); }
        x0 = null;
      });
      show(0); start();
    });
  }

  // Product carousel — arrows scroll by a card width; toggle arrow disabled state.
  function initCarousel() {
    document.querySelectorAll('[data-gg-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      if (!track) return;
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      function step() {
        var card = track.querySelector('.gg-card');
        var w = card ? card.getBoundingClientRect().width : 280;
        return w + 18; // card + gap
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // Customisation zone — pick product, live brand preview, MOQ quantity, summary.

  // Slide-in cart drawer — native Shopify AJAX Cart API (/cart/*.js).
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var empty = drawer.querySelector('[data-cart-empty]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (!body) return; // malformed cart drawer — bail out rather than throw
    var money = function (c) { return ggMoney(c); };
    var panelEl = drawer.querySelector('.gg-cartdrawer__panel');
    if (panelEl) panelEl.setAttribute('tabindex', '-1');
    var cartModal = makeModal(drawer, { initialFocus: '.gg-cartdrawer__panel' });
    var isOpen = false;
    function hide() {
      if (!isOpen) return; isOpen = false;
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); ggUnlockScroll();
      cartModal.deactivate();
    }
    function open() {
      if (isOpen) return; isOpen = true;
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); ggLockScroll();
      cartModal.activate();
      ggOverlayOpened(hide); // phone back button closes the drawer
    }
    function close() { if (!isOpen) return; hide(); ggOverlayClosed(); }
    // display count: whole kit = 1, each made-to-order line = 1, normal = units
    // (mirrors snippets/gg-cart-count.liquid — CB MOQs make raw counts scary)
    function displayCount(c) {
      var n = 0, kit = false;
      (c.items || []).forEach(function (it) {
        var ot = (it.properties && it.properties['_Order type']) || '';
        if (String(ot).indexOf('packs of 10') > -1) kit = true;
        else if (it.properties && it.properties['_Made to order']) n += 1;
        else n += it.quantity;
      });
      return n + (kit ? 1 : 0);
    }
    function setCount(n) {
      document.querySelectorAll('.gg-cart-count').forEach(function (b) { b.textContent = n; b.hidden = n < 1; });
    }
    var focusHint = null; // {key, inc} — which stepper to re-focus after a rebuild
    var lastCart = null;  // kept for the checkout-guard below
    function render(cart) {
      lastCart = cart;
      setCount(displayCount(cart));
      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = ''; body.appendChild(empty); empty.hidden = false; foot.hidden = true; return;
      }
      empty.hidden = true; foot.hidden = false;
      var esc = function (x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      var cbRows = [], normRows = [];
      cart.items.forEach(function (it, i) {
        var img = it.image ? '<img loading="lazy" src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2')) + '" alt="">' : '<i class="ph ph-package" style="font-size:24px;color:#aab09d;display:flex;height:100%;align-items:center;justify-content:center"></i>';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="gg-citem__variant">' + esc(it.variant_title) + '</div>' : '';
        // Business rules mirror the cart page: kit lines step by 10 (min 10);
        // made-to-order lines (a "Clinic name" property) have a per-product MOQ
        // the /cart.js payload can't see — so lock qty editing to the cart page
        // rather than let ±1 push the order below the minimum.
        var props = it.properties || {};
        var isKit = !!props['Kit'];
        var isMTO = !isKit && !!props['Clinic name'];
        var step = isKit ? 10 : 1;
        var minQ = isKit ? 10 : 0;
        // visible custom properties (skip underscore-prefixed / empty)
        var propsHtml = '';
        Object.keys(props).forEach(function (k) {
          if (k.charAt(0) === '_') return;
          var v = props[k]; if (v == null || v === '') return;
          var val = (typeof v === 'string' && /^https?:/.test(v) && v.indexOf('/uploads/') > -1)
            ? '<a href="' + esc(v) + '" target="_blank" rel="noopener">view file</a>' : esc(v);
          propsHtml += '<span class="gg-citem__prop"><b>' + esc(k) + ':</b> ' + val + '</span>';
        });
        if (propsHtml) propsHtml = '<div class="gg-citem__props">' + propsHtml + '</div>';
        var isMultiKit = !!(props['_Order type'] && String(props['_Order type']).indexOf('packs of 10') > -1);
        var qtyBlock = isMultiKit
          ? '<div class="gg-citem__qty gg-citem__qty--locked"><span>Qty ' + it.quantity + '</span></div><a class="gg-citem__editcart" href="/pages/customization-zone#build-now">Kit item · rebuild in studio</a>'
          : isMTO
          ? '<div class="gg-citem__qty gg-citem__qty--locked"><span>Qty ' + it.quantity + '</span></div><a class="gg-citem__editcart" href="/cart">Made to order · edit in cart</a>'
          : '<div class="gg-citem__qty"><button type="button" data-cart-dec aria-label="Decrease"><i class="ph ph-minus" aria-hidden="true"></i></button><span>' + it.quantity + '</span><button type="button" data-cart-inc aria-label="Increase"><i class="ph ph-plus" aria-hidden="true"></i></button></div>';
        var row = '<div class="gg-citem" data-key="' + esc(it.key) + '" data-step="' + step + '" data-min="' + minQ + '"' + (isMultiKit ? ' data-kitline' : '') + '>' +
          '<a class="gg-citem__media" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="gg-citem__info"><a class="gg-citem__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + propsHtml +
          '<div class="gg-citem__controls">' + qtyBlock +
          (isMultiKit ? '' : '<button type="button" class="gg-citem__remove" data-cart-remove>Remove</button>') + '</div></div>' +
          '<div class="gg-citem__price">' + money(it.final_line_price) + '</div>' +
          '</div>';
        // the row that physically carries the uploaded logo file gets flagged so
        // Remove can warn (deleting it silently strips the logo from the order)
        var hasLogoFile = typeof props['Logo'] === 'string' && props['Logo'].indexOf('/uploads/') > -1;
        if (hasLogoFile) row = row.replace('class="gg-citem"', 'class="gg-citem" data-haslogo');
        // clinic-branding lines (customized / kit / made-to-order) group separately
        if (props['Clinic name'] || props['_Made to order'] || props['Kit']) cbRows.push(row);
        else normRows.push(row);
      });
      // group note text comes from the theme setting rendered into [data-cart-mto]
      var mtoSrc = drawer.querySelector('[data-cart-mto]');
      var noteHtml = mtoSrc ? mtoSrc.innerHTML : '<i class="ph ph-info" aria-hidden="true"></i> Production begins only after final design approval.';
      var html = '';
      if (normRows.length) html += normRows.join('');
      if (cbRows.length) {
        var hasKit = cbRows.join('').indexOf('data-kitline') > -1;
        html += '<div class="gg-cdgroup gg-cdgroup--cb">' +
          '<div class="gg-cdgroup__head"><span><i class="ph ph-magic-wand" aria-hidden="true"></i> Clinic Branding · made to order</span>' +
          (hasKit ? '<button type="button" class="gg-cdgroup__kitrm" data-cart-kitremove>Remove kit</button>' : '') + '</div>' +
          '<div class="gg-cdgroup__note">' + noteHtml + '</div>' + cbRows.join('') + '</div>';
      }
      body.innerHTML = html;
      // Restore keyboard focus after the innerHTML rebuild so stepping quantity
      // doesn't throw the user back to the top of the document (WCAG 2.4.3).
      if (focusHint) {
        var restoreRow = body.querySelector('.gg-citem[data-key="' + (window.CSS && CSS.escape ? CSS.escape(focusHint.key) : focusHint.key) + '"]');
        var restoreBtn = restoreRow && restoreRow.querySelector(focusHint.inc ? '[data-cart-inc]' : '[data-cart-dec]');
        if (restoreBtn) { try { restoreBtn.focus(); } catch (e) {} }
        focusHint = null;
      }
      subtotalEl.textContent = money(cart.total_price);
      // free-shipping progress
      var fsWrap = drawer.querySelector('[data-freeship]');
      if (fsWrap) {
        var thr = parseInt(fsWrap.getAttribute('data-freeship'), 10) || 0;
        var msg = fsWrap.querySelector('[data-freeship-msg]');
        var fill = fsWrap.querySelector('[data-freeship-fill]');
        var total = cart.total_price || 0;
        if (thr > 0 && total >= thr) {
          if (msg) { msg.classList.add('is-unlocked'); msg.innerHTML = '<i class="ph ph-check-circle"></i> You’ve unlocked free delivery!'; }
          if (fill) fill.style.width = '100%';
        } else if (thr > 0) {
          if (msg) { msg.classList.remove('is-unlocked'); msg.innerHTML = '<i class="ph ph-truck"></i> Add <strong>' + money(thr - total) + '</strong> for free delivery'; }
          if (fill) fill.style.width = Math.min(100, Math.round(total * 100 / thr)) + '%';
        }
      }
      // approval notice now lives inside the Clinic Branding group above
      var mtoEl = drawer.querySelector('[data-cart-mto]');
      if (mtoEl) mtoEl.hidden = true;
      czGuard(cart);
    }
    // A made-to-order line can only be produced with engraving details and at or
    // above its MOQ. Nothing can add one otherwise any more, but an older cart or
    // a shared cart link still can — so hold checkout here too. Minimums come from
    // [data-cz-moq] (cart.js carries no metafields); kit/studio lines share one
    // minimum across several lines, so only their details are checked.
    function czGuard(cart) {
      var note = drawer.querySelector('[data-cart-block]');
      var btn = drawer.querySelector('[data-cart-checkout]');
      if (!note || !btn) return;
      var esc = function (x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      var moq = {};
      var src = drawer.querySelector('[data-cz-moq]');
      // "handle:100,other-handle:40" — an attribute, not JSON, because Liquid can't
      // emit a bare `}` inside an output tag without tripping its own parser
      (src ? (src.getAttribute('data-cz-moq') || '').split(',') : []).forEach(function (pair) {
        var bits = pair.split(':');
        if (bits.length === 2 && bits[0]) moq[bits[0]] = parseInt(bits[1], 10) || 0;
      });
      var issues = [];
      (cart.items || []).forEach(function (it) {
        if (!Object.prototype.hasOwnProperty.call(moq, it.handle)) return;
        var props = it.properties || {};
        var isKit = !!props['Kit'] || String(props['_Order type'] || '').indexOf('packs of 10') > -1;
        var name = esc(it.product_title);
        if (!props['Clinic name']) issues.push('<b>' + name + '</b> — we need your clinic name to engrave it.');
        else if (!isKit && it.quantity < moq[it.handle]) issues.push('<b>' + name + '</b> — made to order in minimum ' + moq[it.handle] + ' pieces, you have ' + it.quantity + '.');
      });
      if (issues.length) {
        note.innerHTML = '<b><i class="ph ph-warning-circle" aria-hidden="true"></i> One moment before checkout</b><ul><li>' +
          issues.join('</li><li>') + '</li></ul>';
        note.hidden = false;
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      } else {
        note.hidden = true;
        note.innerHTML = '';
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
      }
    }
    function fetchCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart fetch ' + r.status); return r.json(); })
        .then(render)
        .catch(function (e) { if (window.console) console.warn('cart load failed:', e); });
    }
    // Cart mutations are SERIALIZED through a promise chain so concurrent taps
    // can't race /cart/change.js and settle on a stale snapshot. The DOM qty is
    // updated optimistically at click time (below), so bursts accumulate; we
    // only re-render from the server once the queue drains (the latest truth).
    var changeChain = Promise.resolve();
    var changeDepth = 0;
    var lastCartData = null;
    function change(key, qty) {
      changeDepth++;
      body.style.opacity = '.5';
      changeChain = changeChain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) {
          if (!r.ok) {
            // 422 etc: body is an error object, not a cart — reload the REAL cart
            return r.json().then(function (err) {
              alert((err && (err.description || err.message)) || 'Could not update the cart.');
              return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (rr) { return rr.json(); });
            });
          }
          return r.json();
        }).then(function (c) { if (c) lastCartData = c; });
      }).then(function () {
        changeDepth--;
        if (changeDepth === 0) {
          body.style.opacity = '';
          if (lastCartData) {
            render(lastCartData);
            ggAnnounce((qty === 0 ? 'Item removed. ' : 'Cart updated. ') + lastCartData.item_count + (lastCartData.item_count === 1 ? ' item' : ' items') + ', total ' + money(lastCartData.total_price) + '.');
          }
        }
      }).catch(function (e) { changeDepth--; if (changeDepth === 0) body.style.opacity = ''; if (window.console) console.warn('cart update failed:', e); });
      return changeChain;
    }
    // card icon-buttons: no drawer, no text swap — fly the product image into the header cart
    function flyToCart(form) {
      var target = Array.prototype.filter.call(document.querySelectorAll('[data-cart-toggle]'), function (el) { return el.offsetParent !== null; })[0];
      var btn = form.querySelector('[type=submit]');
      if (btn) { // brief success flash on the button itself
        var keep = btn.innerHTML;
        btn.innerHTML = '<i class="ph ph-check" aria-hidden="true"></i> Added';
        btn.classList.add('is-added');
        setTimeout(function () { btn.innerHTML = keep; btn.classList.remove('is-added'); }, 1200);
      }
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var card = form.closest('.gg-card');
      var img = card && card.querySelector('.gg-card__media img');
      if (img && target && !reduce) {
        var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
        var ghost = img.cloneNode();
        ghost.className = 'gg-flyimg';
        ghost.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px';
        document.body.appendChild(ghost);
        var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
        var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.07)';
          ghost.style.opacity = '.3';
        }); });
        setTimeout(function () {
          ghost.remove();
          target.classList.add('gg-cartpulse');
          setTimeout(function () { target.classList.remove('gg-cartpulse'); }, 600);
        }, 700);
      } else if (target) {
        target.classList.add('gg-cartpulse');
        setTimeout(function () { target.classList.remove('gg-cartpulse'); }, 600);
      }
    }
    // intercept add-to-cart forms → AJAX add, then open drawer
    document.addEventListener('submit', function (e) {
      // a form with its own handler (kit builder etc.) owns its submit — never double-add
      if (e.defaultPrevented) return;
      var form = e.target.closest('form[action*="/cart/add"], form.gg-pdp__form');
      if (!form || form.hasAttribute('data-kit-form')) return;
      // let dynamic-checkout (payment_button) submit normally
      if (e.submitter && e.submitter.name === 'checkout') return;
      // file uploads (e.g. customizer logo) must post natively — AJAX would drop the file
      var fileIn = form.querySelector('input[type="file"]:not([disabled])');
      if (fileIn && fileIn.files && fileIn.files.length) return;
      e.preventDefault();
      var qInput = form.querySelector('input[name="quantity"]');
      if (qInput) {
        // AJAX adds skip native constraint validation — re-apply min/step here
        // so no path can land below a product's declared MOQ.
        var q = parseInt(qInput.value, 10); if (!q || q < 1) q = 1;
        var qMin = parseInt(qInput.min, 10), qStep = parseInt(qInput.step, 10);
        if (qMin > 1 && q < qMin) q = qMin;
        if (qStep > 1) q = Math.ceil(q / qStep) * qStep;
        qInput.value = q;
      }
      var fd = new FormData(form);
      var isCard = form.classList.contains('gg-card__cartform');
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; if (!isCard) { btn.dataset._t = btn.innerHTML; btn.innerHTML = 'Adding…'; } }
      if (isCard) {
        // instant feedback: animate + bump the badge now, add in the background
        // (card adds are always 1 plain unit, so +1 is accurate; fetchCart reconciles after)
        flyToCart(form);
        document.querySelectorAll('.gg-cart-count').forEach(function (b) {
          var n = (parseInt(b.textContent, 10) || 0) + 1; b.textContent = n; b.hidden = false;
        });
        ggAnnounce('Item added to your cart.');
      }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) {
              alert((err && (err.description || err.message)) || 'Could not add this item to the cart.');
              return fetchCart().then(function () { throw new Error('add rejected'); });
            });
          }
          return r.json();
        })
        .then(function () { return fetchCart(); })
        .then(function () {
          if (!isCard) { open(); ggAnnounce('Item added to your cart.'); }
        })
        .catch(function (err) { if (err && err.message !== 'add rejected') form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; if (btn.dataset._t) btn.innerHTML = btn.dataset._t; } });
    });
    // open via cart icon
    document.querySelectorAll('[data-cart-toggle]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(open); });
    });
    // close
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', close); });
    // studio multi-product lines carry a combined 100-unit minimum — block the
    // drawer's checkout if edits elsewhere dropped the total below it
    var checkoutForm = drawer.querySelector('.gg-cartdrawer__foot form');
    if (checkoutForm) checkoutForm.addEventListener('submit', function (e) {
      if (!lastCart || !lastCart.items) return;
      var t = 0;
      lastCart.items.forEach(function (it) {
        var p = it.properties || {};
        if (p['_Order type'] && String(p['_Order type']).indexOf('packs of 10') > -1) t += it.quantity;
      });
      if (t > 0 && t < 100) {
        e.preventDefault();
        var mtoEl = drawer.querySelector('[data-cart-mto]');
        if (mtoEl) { mtoEl.hidden = false; mtoEl.innerHTML = '<i class="ph ph-warning-circle" aria-hidden="true"></i> Clinic-branding orders need at least 100 units in total — <a href="/cart">edit your cart</a>.'; }
        if (window.ggAnnounce) ggAnnounce('Clinic-branding orders need at least 100 units in total.');
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // qty + remove (delegated) — respects each line's step/min (kit lines step
    // by 10; made-to-order lines have no ± buttons so only Remove applies)
    body.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-kitremove]')) {
        var kitKeys = Array.prototype.map.call(body.querySelectorAll('.gg-citem[data-kitline]'), function (r) { return r.getAttribute('data-key'); });
        if (!kitKeys.length) return;
        if (!confirm('Remove your whole branding kit from the cart? You can rebuild it in the studio anytime.')) return;
        var lastKey = kitKeys.pop();
        var seq = Promise.resolve();
        kitKeys.forEach(function (k) {
          seq = seq.then(function () {
            return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: k, quantity: 0 }) });
          });
        });
        seq.then(function () { change(lastKey, 0); });
        return;
      }
      var row = e.target.closest('.gg-citem'); if (!row) return;
      var key = row.getAttribute('data-key');
      if (e.target.closest('[data-cart-remove]')) {
        if (row.hasAttribute('data-haslogo') && document.querySelectorAll('.gg-cdgroup--cb .gg-citem').length > 1 &&
            !confirm('This item carries your uploaded logo — removing it removes the logo from your whole branding order. Continue? (You can re-send the logo on WhatsApp during design approval.)')) return;
        change(key, 0); return;
      }
      var span = row.querySelector('.gg-citem__qty span');
      var qty = parseInt(span.textContent.replace(/\D/g, ''), 10);
      if (isNaN(qty)) return;
      var step = parseInt(row.getAttribute('data-step') || '1', 10) || 1;
      var minQ = parseInt(row.getAttribute('data-min') || '0', 10) || 0;
      var next;
      if (e.target.closest('[data-cart-inc]')) next = qty + step;
      else if (e.target.closest('[data-cart-dec]')) { next = qty - step; if (next < minQ) next = minQ; }
      else return;
      if (next === qty) return;
      focusHint = { key: key, inc: !!e.target.closest('[data-cart-inc]') };
      span.textContent = next; // optimistic — keeps rapid taps accurate before re-render
      change(key, next);
    });
  }

  // Shared money formatter — matches the shop's "Rs. {{amount}}" format so every
  // JS-rendered price (drawer, PDP, kit, studio) reads identically. Indian
  // grouping, always 2 decimals.
  function ggMoney(cents) {
    // whole rupees stay whole (Rs. 80, not Rs. 80.00); paise show only when real
    var amt = Math.round(cents) / 100;
    var whole = amt === Math.round(amt);
    try {
      return 'Rs. ' + amt.toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    } catch (e) { return 'Rs. ' + (whole ? amt : amt.toFixed(2)); }
  }
  window.ggMoney = ggMoney;

  // Product page: wire option radios -> variant id, price, availability, image, URL, stock.
  function initProductForm() {
    document.querySelectorAll('form.gg-pdp__form').forEach(function (form) {
      var info = form.closest('.gg-pdp__info') || document;
      var pdp = form.closest('.gg-pdp') || document;
      var gallery = pdp.querySelector('[data-gallery-main]');

      // Swap the main image. The main <img> carries a responsive `srcset` for the
      // featured image; that srcset wins over `src`, so it MUST be removed when we
      // switch, otherwise the visible image never changes. (sizes is harmless.)
      function showImage(url) {
        if (!gallery || !url) return;
        gallery.removeAttribute('srcset');
        gallery.src = url;
      }

      // Gallery thumbnails: wired FIRST and independently, so they always work
      // even if the variant data is missing or malformed.
      var thumbs = pdp.querySelectorAll('[data-thumb]');
      function setActiveThumb(full) {
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-full') === full); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          showImage(t.getAttribute('data-full'));
          setActiveThumb(t.getAttribute('data-full'));
        });
      });
      // Variant image SETS: thumbs tagged data-vopt (alt text names an option
      // value) belong to that value's set. When 2+ sets exist, show only the
      // selected variant's set; untagged thumbs are shared and always visible.
      var setThumbs = Array.prototype.filter.call(thumbs, function (t) { return t.hasAttribute('data-vopt'); });
      var setVals = {};
      setThumbs.forEach(function (t) { setVals[t.getAttribute('data-vopt')] = 1; });
      var setCount = Object.keys(setVals).length;
      var syncThumbNav = null; // assigned by the slider block below
      function filterThumbSets(opts) {
        if (setCount < 2) return;
        var low = opts.map(function (o) { return String(o).toLowerCase(); });
        setThumbs.forEach(function (t) {
          t.hidden = low.indexOf(t.getAttribute('data-vopt')) === -1;
        });
        // strip contents changed: snap to the start and re-sync the arrows
        if (thumbStrip) thumbStrip.scrollTo({ left: 0 });
        if (syncThumbNav) requestAnimationFrame(syncThumbNav);
      }
      // Thumbnail slider: each arrow pages one screen and hides at its own
      // edge — right arrow gone at the end, left arrow gone at the start.
      var thumbStrip = pdp.querySelector('[data-thumbs]');
      var thumbNext = pdp.querySelector('[data-thumbs-next]');
      var thumbPrev = pdp.querySelector('[data-thumbs-prev]');
      if (thumbStrip && thumbNext) {
        var atEnd = function () { return thumbStrip.scrollLeft >= (thumbStrip.scrollWidth - thumbStrip.clientWidth - 4); };
        var syncNav = function () {
          var scrollable = thumbStrip.scrollWidth > thumbStrip.clientWidth + 4;
          thumbNext.hidden = !scrollable || atEnd();
          if (thumbPrev) thumbPrev.hidden = !scrollable || thumbStrip.scrollLeft <= 4;
        };
        thumbNext.addEventListener('click', function () {
          thumbStrip.scrollBy({ left: thumbStrip.clientWidth, behavior: 'smooth' });
        });
        if (thumbPrev) thumbPrev.addEventListener('click', function () {
          thumbStrip.scrollBy({ left: -thumbStrip.clientWidth, behavior: 'smooth' });
        });
        thumbStrip.addEventListener('scroll', function () { requestAnimationFrame(syncNav); }, { passive: true });
        window.addEventListener('resize', syncNav);
        syncThumbNav = syncNav;
        syncNav();
      }

      // Warm the full-size gallery images so switching is instant — but politely:
      // one at a time, at low priority, and only after the page has settled. A
      // parallel burst here fights the LCP image and Shopify's checkout preload
      // for bandwidth on slow connections (it's why galleries felt slow on 4G).
      if (thumbs.length > 1) {
        var warmGallery = function () {
          var urls = [];
          thumbs.forEach(function (t) { var u = t.getAttribute('data-full'); if (u) urls.push(u); });
          var i = 0;
          var next = function () {
            if (i >= urls.length) return;
            var im = new Image();
            im.decoding = 'async';
            if ('fetchPriority' in im) im.fetchPriority = 'low';
            im.onload = im.onerror = function () { setTimeout(next, 150); };
            im.src = urls[i++];
          };
          next();
        };
        var kickoff = function () {
          if ('requestIdleCallback' in window) requestIdleCallback(warmGallery, { timeout: 4000 });
          else setTimeout(warmGallery, 3000);
        };
        if (document.readyState === 'complete') kickoff();
        else window.addEventListener('load', kickoff, { once: true });
      }

      var dataEl = form.querySelector('[data-variant-json]');
      var idInput = form.querySelector('[data-variant-id]');
      if (!dataEl || !idInput) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var priceNow = info.querySelector('[data-price-now]');
      var priceMrp = info.querySelector('[data-price-mrp]');
      var priceOff = info.querySelector('[data-price-off]');
      var stockEl = info.querySelector('[data-variant-inventory]');
      var addBtn = form.querySelector('[data-cart-add]');
      var radios = form.querySelectorAll('input[name^="option-"]');

      // When a variant has no assigned image, try to find a gallery image whose
      // ALT text or filename mentions the selected option value (e.g. "Blue").
      function imageForOptions(opts) {
        for (var i = 0; i < opts.length; i++) {
          var needle = opts[i].toLowerCase();
          var dashed = needle.replace(/\s+/g, '-');
          for (var j = 0; j < thumbs.length; j++) {
            var img = thumbs[j].querySelector('img');
            var alt = (img && img.alt || '').toLowerCase();
            var url = (thumbs[j].getAttribute('data-full') || '').toLowerCase();
            if ((alt && alt.indexOf(needle) > -1) || url.indexOf(dashed) > -1 || url.indexOf(needle.replace(/\s+/g, '')) > -1) {
              return thumbs[j].getAttribute('data-full');
            }
          }
        }
        return null;
      }
      function selectedOptions() {
        return Array.prototype.map.call(form.querySelectorAll('input[name^="option-"]:checked'), function (r) { return r.value; });
      }
      // Colours start unselected — count option groups so update() can tell a
      // partial selection (waiting on the shopper) from a complete one.
      var optionGroupCount = (function () {
        var names = {};
        radios.forEach(function (r) { names[r.name] = 1; });
        return Object.keys(names).length;
      })();
      var allSoldOut = variants.length > 0 && variants.every(function (v) { return !v.available; });
      var dynamicPay = form.querySelector('[data-dynamic-pay]');
      var packBadge = pdp.querySelector('[data-packbadge][data-pack-alt-for], [data-packbadge][data-pack-map]');
      // Per-variant pack map ({variantId: "Pack of N"}) — for products where
      // different variants ship in different pack quantities (e.g. Bite
      // Registration Tray: 50/35/30 per bag). Takes precedence over the older
      // single alt-value mechanism when present.
      var packMap = null;
      if (packBadge && packBadge.getAttribute('data-pack-map')) {
        try { packMap = JSON.parse(packBadge.getAttribute('data-pack-map')); } catch (e) { packMap = null; }
      }
      var firstPaint = true;   // cleared right after the initial update() below
      var urlVariant = false;
      try { urlVariant = !!new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
      function matchVariant(opts) {
        if (!opts.length) return variants[0];
        return variants.find(function (v) {
          return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      // Only offer option values that exist in combination with the choices made
      // in earlier option groups (e.g. Large and Small trays come in different
      // colors — picking a size narrows the color pills to that size's colors).
      function refreshOptionVisibility() {
        var groups = {};
        radios.forEach(function (r) { (groups[r.name] = groups[r.name] || []).push(r); });
        var names = Object.keys(groups).sort();
        names.forEach(function (name, gi) {
          var prior = names.slice(0, gi).map(function (n) {
            var c = groups[n].filter(function (r) { return r.checked; })[0];
            return c ? c.value : null;
          });
          var lostChecked = false;

          var matchesFor = function (r) {
            return variants.filter(function (v) {
              return prior.every(function (p, i) { return p === null || v.options[i] === p; }) && v.options[gi] === r.value;
            });
          };

          // Prices are compared WITHIN the group, not against the whole product:
          // otherwise picking a dearer Type stamps a price onto every colour below
          // it — true, but noise, since that cost belongs to the Type row.
          // We show the ACTUAL price, never "+₹900" — a delta makes the shopper ask
          // "more than what?", which is a question a label should never provoke.
          var groupBase = Infinity, groupTop = 0;
          groups[name].forEach(function (r) {
            matchesFor(r).forEach(function (v) {
              if (v.price < groupBase) groupBase = v.price;
              if (v.price > groupTop) groupTop = v.price;
            });
          });
          var priceVaries = groupTop > groupBase;

          groups[name].forEach(function (r) {
            var matches = matchesFor(r);
            var lab = r.closest('.gg-pdp__opt');
            var exists = matches.length > 0;

            // Combinations that don't exist are hidden entirely; the first option
            // group always shows every value, since nothing precedes it.
            if (lab && gi > 0) lab.hidden = !exists;
            if (gi > 0 && !exists && r.checked) { r.checked = false; lostChecked = true; }
            if (!lab || !exists) return;

            // Exists but nothing sellable in it → sold out. Shown, not hidden:
            // hiding it would imply the colour was never offered.
            var sellable = matches.filter(function (v) { return v.available; });
            lab.classList.toggle('is-soldout', sellable.length === 0);

            var cap = lab.querySelector('[data-optcap]');
            if (!cap) return;
            var text = '';
            // The selected option needs no caption: its price is the headline price,
            // its stock is the line under the buttons, and "sold out" is the button
            // itself. Captions exist to describe the options you HAVEN'T picked.
            if (r.checked) { cap.textContent = ''; return; }
            if (sellable.length === 0) {
              text = 'Sold out';
            } else {
              var minPrice = Math.min.apply(null, matches.map(function (v) { return v.price; }));
              var stock = sellable.reduce(function (s, v) { return s + (v.managed ? (v.qty > 0 ? v.qty : 0) : 999); }, 0);
              if (priceVaries && window.ggMoney && minPrice > groupBase) {
                // A price caption only where picking the option actually costs
                // more than the group's cheapest path. Options that match the
                // base price stay quiet — a matching price is noise, not news.
                text = ggMoney(minPrice);
              }
              if (!text && stock > 0 && stock <= 5) text = stock + ' left';
              // Per-variant pack quantities (when they differ, price alone is
              // not comparable) — compact form: "Pack of 50" → "50 pcs".
              if (!text && packMap && matches[0]) {
                var pk = packMap[String(matches[0].id)] || '';
                var pm = pk.match(/\d+/);
                if (pm) text = pm[0] + ' pcs';
              }
            }
            cap.textContent = text;
          });

          // Re-pick ONLY when a previous choice was narrowed away (lostChecked).
          // A group the shopper never touched stays unselected — colours start
          // blank by design and must not self-select.
          if (gi > 0 && lostChecked) {
            var first = groups[name].filter(function (r) { var l = r.closest('.gg-pdp__opt'); return !l || !l.hidden; })[0];
            if (first) first.checked = true;
          }
        });
      }
      function update() {
        refreshOptionVisibility();
        var opts = selectedOptions();
        // A colour is still unchosen: hold the neutral state — cover image,
        // base price, and a button that asks for the choice instead of adding.
        if (opts.length < optionGroupCount) {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.innerHTML = '<i class="gg-cart-ic"></i> ' + (allSoldOut ? 'Sold out' : 'Select a colour');
          }
          if (stockEl) stockEl.textContent = '';
          if (dynamicPay) dynamicPay.classList.add('is-gated');
          return;
        }
        if (dynamicPay) dynamicPay.classList.remove('is-gated');
        var v = matchVariant(opts);
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.innerHTML = '<i class="ph ph-x-circle"></i> Unavailable'; }
          if (stockEl) { stockEl.textContent = 'This combination is not available'; stockEl.style.color = 'var(--fg-subtle)'; }
          return;
        }
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = ggMoney(v.price);
        if (priceMrp && priceOff) {
          if (v.compare_at && v.compare_at > v.price) {
            priceMrp.textContent = ggMoney(v.compare_at); priceMrp.style.display = '';
            priceOff.textContent = Math.round((v.compare_at - v.price) * 100 / v.compare_at) + '% off'; priceOff.style.display = '';
          } else { priceMrp.style.display = 'none'; priceOff.style.display = 'none'; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.innerHTML = '<i class="gg-cart-ic"></i> ' + (v.available ? 'Add to cart' : 'Sold out');
        }
        if (stockEl) {
          if (!v.available) { stockEl.textContent = 'Out of stock'; stockEl.style.color = 'var(--danger,#c0392b)'; }
          else if (v.managed && v.qty > 0 && v.qty <= 10) { stockEl.textContent = 'Only ' + v.qty + ' left in stock'; stockEl.style.color = 'var(--gg-green-text)'; }
          else { stockEl.textContent = 'In stock'; stockEl.style.color = 'var(--ok,#5fae46)'; }
        }
        // "pack of 10" for a single size, "set of 10" for the mixed pack —
        // or, with a per-variant map, each variant's own pack quantity.
        if (packBadge) {
          var packText = packBadge.querySelector('[data-packtext]');
          var txt = '';
          if (packMap) {
            txt = packMap[String(v.id)] || '';
          } else {
            var altFor = (packBadge.getAttribute('data-pack-alt-for') || '').toLowerCase();
            var isAlt = (v.options || []).some(function (o) { return String(o).toLowerCase() === altFor; });
            txt = isAlt ? packBadge.getAttribute('data-pack-alt') : packBadge.getAttribute('data-pack-base');
          }
          if (packText && txt) { packText.textContent = txt; packBadge.setAttribute('aria-label', 'Pack size: ' + txt); }
        }
        if (gallery) {
          filterThumbSets(v.options || []);
          // On first paint keep the cover image the template rendered. Swapping
          // straight to the pre-selected variant's photo hides the product's own
          // hero before the shopper has chosen anything. A ?variant= link IS an
          // explicit choice, so that still wins.
          if (!firstPaint || urlVariant) {
            var vimg = v.image || imageForOptions(v.options || []);
            if (vimg) { showImage(vimg); setActiveThumb(vimg); }
          }
        }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
      }

      // Colour swatches carry no text, so the chosen value is named beside the
      // option label ("Color: Peach") — otherwise a shopper can't tell a swatch
      // apart from its neighbour, or say which one they picked.
      function syncOptionLabels() {
        form.querySelectorAll('[data-optlabel]').forEach(function (el) {
          var pos = el.getAttribute('data-optlabel');
          var checked = form.querySelector('input[name="option-' + pos + '"]:checked');
          if (checked) el.textContent = checked.value;
        });
      }
      radios.forEach(function (r) { r.addEventListener('change', function () { update(); syncOptionLabels(); }); });
      syncOptionLabels();
      update();
      firstPaint = false;   // every later update() is a real shopper choice
    });
  }

  // Promotional popup: delayed show, once per N days, copy-code, editor-aware.
  function initPromoPopup() {
    var promo = document.querySelector('[data-promo]');
    if (!promo) return;
    var key = 'gg-promo-' + (promo.getAttribute('data-key') || 'offer');
    var days = parseInt(promo.getAttribute('data-days') || '7', 10);
    var delay = parseInt(promo.getAttribute('data-delay') || '3', 10) * 1000;
    var designMode = window.Shopify && window.Shopify.designMode;

    var promoBox = promo.querySelector('.gg-promo__box') || promo;
    var promoModal = makeModal(promoBox, { initialFocus: '.gg-promo__x' });
    var promoOpen = false;
    function show() {
      if (promoOpen) return; promoOpen = true;
      promo.classList.add('is-open'); promo.setAttribute('aria-hidden', 'false');
      promoModal.activate();
    }
    function hide(remember) {
      if (!promoOpen) return; promoOpen = false;
      promo.classList.remove('is-open'); promo.setAttribute('aria-hidden', 'true');
      promoModal.deactivate();
      if (remember) { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
    }
    promo.querySelectorAll('[data-promo-close]').forEach(function (el) {
      el.addEventListener('click', function () { hide(true); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && promo.classList.contains('is-open')) hide(true); });

    var codeBtn = promo.querySelector('[data-promo-code]');
    if (codeBtn) codeBtn.addEventListener('click', function () {
      var code = codeBtn.querySelector('span').textContent.trim();
      var done = function () { codeBtn.classList.add('is-copied'); codeBtn.querySelector('i').className = 'ph ph-check'; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done);
      else done();
    });

    if (designMode) {
      // In the theme editor: show only while the section is selected.
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(promo)) show(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(promo)) hide(false); });
      return;
    }
    var last = 0;
    try { last = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
    if (last && (Date.now() - last) < days * 86400000) return;
    setTimeout(show, delay);
  }

  // Collection category bar: range chips expand to show their sub-categories.
  // iOS Low Power Mode blocks video autoplay; the first user gesture re-arms it.
  // Nudge every paused ambient video back to life on first touch / page restore.
  function kickAmbientVideos() {
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      if (v.paused && !v.hasAttribute('data-gg-off')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }
  // Pause ambient videos while offscreen (long pages with several videos push
  // iOS to evict decoders — videos come back black). Resume on re-entry,
  // reloading first if the buffer was dropped.
  if ('IntersectionObserver' in window) {
    var ggVidIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          v.removeAttribute('data-gg-off');
          if (v.error || (v.readyState === 0 && v.currentSrc)) { try { v.load(); } catch (e) {} }
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else {
          v.setAttribute('data-gg-off', '');
          if (!v.paused) v.pause();
        }
      });
    }, { rootMargin: '25% 0px' });
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      ggVidIO.observe(v);
      // autoplay can kick in after the observer already marked it offscreen
      v.addEventListener('play', function () { if (v.hasAttribute('data-gg-off')) v.pause(); });
    });
  }
  document.addEventListener('touchstart', kickAmbientVideos, { once: true, passive: true });
  window.addEventListener('pageshow', function (e) { if (e.persisted) kickAmbientVideos(); });

  function initCatbar() {
    var bar = document.querySelector('[data-catbar]');
    if (!bar) return;
    var toggles = bar.querySelectorAll('[data-catbar-toggle]');
    var panels = document.querySelectorAll('[data-catbar-panel]');

    // Load the clicked range's own products into the grid below (same swap
    // pattern as the live product search: grid + count + pager + title).
    // The add-to-cart submit handler is document-delegated, so swapped-in
    // cards keep working. pushState so sort/filters/pagination then act on
    // the loaded collection.
    var loadToken = 0;
    function loadRange(url) {
      var grid = document.querySelector('[data-prodgrid]');
      if (!grid) return;
      var my = ++loadToken;
      grid.style.opacity = '.45';
      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (my !== loadToken) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('[data-prodgrid]');
          if (!g) return;
          grid.innerHTML = g.innerHTML;
          grid.querySelectorAll('.gg-reveal').forEach(function (el) { el.classList.add('is-in'); });
          var cNew = doc.querySelector('[data-prodcount]'), cOld = document.querySelector('[data-prodcount]');
          if (cNew && cOld) cOld.textContent = cNew.textContent;
          var pOld = document.querySelector('.gg-collection .gg-pager');
          var pNew = doc.querySelector('.gg-collection .gg-pager');
          if (pOld && pNew) pOld.outerHTML = pNew.outerHTML;
          else if (pOld) pOld.remove();
          else if (pNew && grid.parentNode) grid.insertAdjacentHTML('afterend', pNew.outerHTML);
          var tNew = doc.querySelector('.gg-collection__title'), tOld = document.querySelector('.gg-collection__title');
          if (tNew && tOld) tOld.textContent = tNew.textContent;
          try { history.pushState({}, '', url); } catch (e) {}
        })
        .catch(function () {})
        .then(function () { if (my === loadToken) grid.style.opacity = ''; });
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-catbar-toggle');
        var willOpen = btn.getAttribute('aria-expanded') !== 'true';
        toggles.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.classList.remove('is-open'); });
        panels.forEach(function (p) { p.hidden = true; });
        if (willOpen) {
          btn.setAttribute('aria-expanded', 'true');
          btn.classList.add('is-open');
          var panel = document.querySelector('[data-catbar-panel="' + i + '"]');
          if (panel) panel.hidden = false;
          var src = btn.getAttribute('data-catbar-fetch');
          if (src) loadRange(src);
        }
      });
    });
  }

  // Build-your-own branding kit: accumulate customised lines, enforce a
  // COMBINED minimum across all items, then push every line to the cart.

  // Inline product-page customizer: engraving fields ride the product form as
  // line-item properties; logo file forces a native multipart submit.
  function initPdpCustomizer() {
    var cz = document.querySelector('[data-pdpcz]');
    if (!cz) return;
    var form = cz.closest('form');
    if (!form) return;
    form.setAttribute('enctype', 'multipart/form-data');
    var moq = parseInt(cz.getAttribute('data-moq') || '1', 10);
    var step = parseInt(cz.getAttribute('data-step') || '1', 10);
    var qty = form.querySelector('input[name="quantity"]');
    var nameIn = cz.querySelector('[data-pdpcz-name]');
    var tagIn = cz.querySelector('[data-pdpcz-tag]');
    var logoIn = cz.querySelector('[data-pdpcz-logo]');
    var flag = cz.querySelector('[data-pdpcz-flag]');
    var prevName = cz.querySelector('[data-pdpcz-prevname]');
    var prevDoc = cz.querySelector('[data-pdpcz-prevdoc]');
    var docIn = cz.querySelector('[data-pdpcz-doc]');
    var prevTag = cz.querySelector('[data-pdpcz-prevtag]');

    // Live line total = current variant price (paise) × quantity
    var vjsonEl = form.querySelector('[data-variant-json]');
    var variants = []; try { variants = JSON.parse(vjsonEl.textContent); } catch (e) {}
    var idInput = form.querySelector('[data-variant-id]');
    var ltEl = form.querySelector('[data-pdp-linetotal]');
    function curPrice() {
      var id = idInput ? parseInt(idInput.value, 10) : 0;
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) return variants[i].price; }
      return variants[0] ? variants[0].price : 0;
    }
    function updateTotal() {
      if (!ltEl || !qty) return;
      var q = parseInt(qty.value || '0', 10) || 0;
      ltEl.textContent = ggMoney(curPrice() * q);
    }

    function setActive(on) {
      // fields only submit when the customizer is open
      cz.querySelectorAll('input, textarea, select').forEach(function (i) { i.disabled = !on; });
      if (flag) flag.disabled = !on;
      if (nameIn) nameIn.required = on;   // clinic/doctor name REQUIRED — no add without it
      // logo stays OPTIONAL — never forced required
      if (on && qty) {
        qty.setAttribute('step', step);
        qty.setAttribute('min', moq);
        if (parseInt(qty.value || '0', 10) < moq) qty.value = moq;
        updateTotal();
      } else if (qty) { qty.removeAttribute('step'); }
    }
    cz.addEventListener('toggle', function () { setActive(cz.open); });
    setActive(cz.open);
    // keep the line total live on qty change and variant switch
    form.addEventListener('change', function () { setTimeout(updateTotal, 0); });
    updateTotal();

    if (nameIn && prevName) nameIn.addEventListener('input', function () { prevName.textContent = nameIn.value.trim() || 'Your Clinic'; });
    if (docIn && prevDoc) docIn.addEventListener('input', function () { prevDoc.textContent = docIn.value.trim(); });
    if (tagIn && prevTag) tagIn.addEventListener('input', function () { prevTag.textContent = tagIn.value.trim(); });
    var addrIn = cz.querySelector('[data-pdpcz-addr]');
    var prevAddr = cz.querySelector('[data-pdpcz-prevaddr]');
    if (addrIn && prevAddr) addrIn.addEventListener('input', function () { prevAddr.textContent = addrIn.value.trim(); });
    var prevLogo = cz.querySelector('[data-pdpcz-prevlogo]');
    var prevFile = cz.querySelector('[data-pdpcz-prevfile]');
    if (logoIn) logoIn.addEventListener('change', function () {
      var f = logoIn.files && logoIn.files[0];
      if (prevLogo) prevLogo.hidden = true;
      if (prevFile) prevFile.hidden = true;
      if (!f) return;
      if (f.size > 10 * 1024 * 1024) { alert('Logo file is over 10MB — please use a smaller file.'); logoIn.value = ''; return; }
      if (f.type.indexOf('image/') === 0 && prevLogo) {
        // image logos render live in the engraving preview, VistaPrint-style
        var rd = new FileReader();
        rd.onload = function (e) { prevLogo.src = e.target.result; prevLogo.hidden = false; };
        rd.readAsDataURL(f);
      } else if (prevFile) {
        // non-image files (PDF) show as an attached-file chip
        prevFile.querySelector('span').textContent = f.name;
        prevFile.hidden = false;
      }
    });
    if (qty) {
      // MOQ is a hard floor on every path — including Buy It Now, which skips
      // both native validation and the submit event (how a 50-pc order slipped
      // through on a 100 MOQ). Never conditional on the panel being open.
      var clamp = function () {
        var v = parseInt(qty.value || '0', 10);
        if (v < moq) v = moq;
        if (step > 1) v = Math.ceil(v / step) * step;
        qty.value = v;
      };
      qty.addEventListener('change', clamp);
      form.addEventListener('submit', clamp);
      // Dynamic checkout reads the form in its own click handler; capture-phase
      // pointerdown + click run first, so it always reads the corrected value.
      var guardDynamic = function (e) {
        if (e.target.closest('.shopify-payment-button, [data-shopify="payment-button"], .gg-pdp__dynamic')) clamp();
      };
      form.addEventListener('pointerdown', guardDynamic, true);
      form.addEventListener('click', guardDynamic, true);
    }
  }

  // Article body: wrap bare video embeds (YouTube/Vimeo iframes pasted in the
  // admin editor) in a responsive 16:9 box so they don't overflow on mobile.
  function initArticleMedia() {
    document.querySelectorAll('.gg-rte iframe').forEach(function (fr) {
      if (fr.closest('.gg-rte__video')) return;
      var wrap = document.createElement('div');
      wrap.className = 'gg-rte__video';
      fr.parentNode.insertBefore(wrap, fr);
      wrap.appendChild(fr);
    });
  }

  // Mega-menu featured product slider: auto-rotate, dots, pause on hover.
  function initMegaFeat() {
    document.querySelectorAll('[data-megafeat]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-megafeat-slide]');
      var dots = root.querySelectorAll('[data-megafeat-dot]');
      if (slides.length < 2) return;
      var i = 0, timer = null;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { if (reduce) return; stop(); timer = setInterval(function () { show(i + 1); }, 3500); }
      dots.forEach(function (d, k) { d.addEventListener('click', function (e) { e.preventDefault(); show(k); start(); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    });
  }

  // Show a backdrop behind the mega menus on hover/focus (JS-driven, robust).
  function initMegaBackdrop() {
    var bd = document.querySelector('.gg-megabackdrop');
    if (!bd) return;
    // Move to <body> so position:fixed is viewport-relative (never trapped by a transformed ancestor).
    if (bd.parentNode !== document.body) document.body.appendChild(bd);
    document.querySelectorAll('.gg-nav__item').forEach(function (item) {
      if (!item.querySelector('.gg-hmega, .gg-mega')) return;
      var show = function () { bd.classList.add('is-on'); };
      var hide = function () { bd.classList.remove('is-on'); };
      item.addEventListener('mouseenter', show);
      item.addEventListener('mouseleave', hide);
      item.addEventListener('focusin', show);
      item.addEventListener('focusout', hide);
    });
  }

  // Desktop: clicking "Hygiene Range" opens the mega menu (same one as hover)
  // instead of navigating. Hover still opens it; no-JS users still get the link.
  function initHmegaClick() {
    var links = document.querySelectorAll('[data-hmega-link]');
    if (!links.length) return;
    var desktop = function () { return window.matchMedia('(hover:hover) and (pointer:fine)').matches; };
    function closeAll(except) {
      document.querySelectorAll('.gg-nav__item.is-open').forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var a = it.querySelector('[data-hmega-link]');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }
    links.forEach(function (a) {
      var item = a.closest('.gg-nav__item');
      if (!item) return;
      a.addEventListener('click', function (e) {
        if (!desktop()) return;               // mobile uses the drawer overlay
        e.preventDefault();
        var open = item.classList.toggle('is-open');
        a.setAttribute('aria-expanded', open ? 'true' : 'false');
        closeAll(item);
      });
      // hovering away closes the click-opened state too, so it behaves like the hover menu
      item.addEventListener('mouseleave', function () {
        item.classList.remove('is-open');
        a.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.gg-nav__item.is-open')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

    // Close the mega menu when the page scrolls (CSS :hover would otherwise keep it open).
    var navEl = document.querySelector('.gg-nav');
    var bd = document.querySelector('.gg-megabackdrop');
    window.addEventListener('scroll', function () {
      closeAll(null);
      if (bd) bd.classList.remove('is-on');
      if (navEl) navEl.classList.add('gg-nav--noopen');
    }, { passive: true });
    // Re-enable hover-to-open once the pointer actually moves again.
    document.addEventListener('mousemove', function () {
      if (navEl && navEl.classList.contains('gg-nav--noopen')) navEl.classList.remove('gg-nav--noopen');
    }, { passive: true });
  }

  // Mobile search: the icon expands the header bar into a search field and back.
  // The icon keeps its /search href, so this is pure enhancement — if the script
  // never runs, tapping it still reaches the search page.
  function initMobileSearch() {
    var opener = document.querySelector('[data-msearch-open]');
    var form = document.querySelector('[data-msearch]');
    if (!opener || !form) return;
    var bar = form.closest('.gg-site-header__bar');
    var input = form.querySelector('[data-msearch-input]');
    if (!bar || !input) return;

    function open(e) {
      if (e) e.preventDefault();
      bar.classList.add('is-searching');
      opener.setAttribute('aria-expanded', 'true');
      setTimeout(function () { input.focus(); }, 60); // after the bar has swapped
    }
    function close() {
      bar.classList.remove('is-searching');
      opener.setAttribute('aria-expanded', 'false');
      input.value = '';
      // collapse any predictive dropdown this form opened
      var panel = form.querySelector('.gg-suggest');
      if (panel) panel.hidden = true;
    }
    opener.addEventListener('click', open);
    form.querySelectorAll('[data-msearch-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && bar.classList.contains('is-searching')) close();
    });
    // leaving mobile widths with the bar open would strand it — reset
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 1201px)');
      var onWide = function (e) { if (e.matches) close(); };
      if (mq.addEventListener) mq.addEventListener('change', onWide);
      else if (mq.addListener) mq.addListener(onWide);
    }
  }

  // Account links leave for shopify.com (hosted accounts) — that navigation takes a
  // couple of seconds on mobile networks, so spin the icon immediately on tap.
  function initAccountFeedback() {
    document.querySelectorAll('[data-account-link]').forEach(function (a) {
      a.addEventListener('click', function () {
        var ic = a.querySelector('i');
        if (ic) { ic.className = 'ph ph-circle-notch'; ic.style.animation = 'gg-spin .7s linear infinite'; }
      });
    });
  }

  // Dark/light theme toggle. The initial theme is set in <head> (no flash):
  // saved choice wins; otherwise AUTO — follow the device's light/dark setting,
  // live (data-gg-theme-auto marks auto mode; a manual toggle exits it for good).
  function initThemeToggle() {
    var root = document.documentElement;
    var toggles = document.querySelectorAll('[data-theme-toggle]');
    function sync() {
      var dark = root.getAttribute('data-theme') !== 'light';
      toggles.forEach(function (t) { t.setAttribute('aria-checked', dark ? 'true' : 'false'); });
    }
    // AUTO mode: flip live when the phone flips (e.g. iOS auto dark at night)
    if (root.hasAttribute('data-gg-theme-auto') && window.matchMedia) {
      var mq = window.matchMedia('(prefers-color-scheme: dark)');
      var onSystemChange = function (e) {
        if (!root.hasAttribute('data-gg-theme-auto')) return; // manual choice made since
        root.setAttribute('data-theme', e.matches ? 'dark' : 'light');
        sync();
        document.dispatchEvent(new Event('gg:themechange'));
      };
      if (mq.addEventListener) mq.addEventListener('change', onSystemChange);
      else if (mq.addListener) mq.addListener(onSystemChange); // older iOS Safari
    }
    if (!toggles.length) return;
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
        root.removeAttribute('data-gg-theme-auto'); // explicit choice ends auto-follow
        root.setAttribute('data-theme', next);
        try { localStorage.setItem('gg-theme', next); } catch (e) {}
        sync();
        document.dispatchEvent(new Event('gg:themechange')); // let canvases re-read colors
      });
    });
    sync();
  }

  // Theme-aware WebGL "cell-flow" background. Renders on any [data-cells-bg]
  // canvas, reads the brand tokens (so it flips with dark/light), and softens
  // with a CSS blur. Paused off-screen; static under prefers-reduced-motion.
  function tokenRGB(name, fallback) {
    var v = (getComputedStyle(document.documentElement).getPropertyValue(name) || '').trim() || fallback;
    v = v.replace('#', '');
    if (v.length === 3) v = v[0] + v[0] + v[1] + v[1] + v[2] + v[2];
    var n = parseInt(v, 16); if (isNaN(n)) n = parseInt(fallback.replace('#', ''), 16);
    return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
  }
  function initCellsBg() {
    var canvases = document.querySelectorAll('[data-cells-bg]');
    if (!canvases.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    canvases.forEach(function (cv) { setupCellsBg(cv, reduce); });
  }
  function setupCellsBg(cv, reduce) {
    var gl = cv.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: false, depth: false })
          || cv.getContext('experimental-webgl', { alpha: true, premultipliedAlpha: false });
    if (!gl) { cv.style.display = 'none'; return; }
    var VS = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.0,1.0);}';
    var FS =
      'precision highp float;uniform vec2 u_res;uniform float u_time;uniform vec3 u_cell;uniform vec3 u_soft;const int N=11;' +
      'float hash(float n){return fract(sin(n)*43758.5453123);}' +
      'void main(){' +
      'float asp=u_res.x/u_res.y;' +
      'vec2 p=gl_FragCoord.xy/u_res.y;' +
      'float t=u_time*0.17;' +
      'p+=0.06*vec2(sin(p.y*3.1+t*2.0),cos(p.x*3.1+t*1.6));' +   // organic flow
      'float field=0.0;' +
      'for(int i=0;i<N;i++){float fi=float(i);' +
      'float sd=hash(fi*1.31),sd2=hash(fi*2.7+1.0);' +
      'vec2 c=vec2(hash(fi*0.71)*asp,hash(fi*1.93));' +
      'float sp=0.5+sd;' +
      'c+=vec2(sin(t*sp+fi*1.7),cos(t*sp*0.8+fi*2.3))*0.32;' +
      'float d=distance(p,c);float r=0.09+sd2*0.10;' +
      'field+=r*r/(d*d+0.0009);}' +                              // metaball field (cells merge/divide)
      'float cell=smoothstep(0.6,1.45,field);' +
      'float edge=exp(-pow((field-1.0)*2.8,2.0));' +            // bright membrane near the threshold
      'vec3 col=mix(u_cell,u_soft,edge);' +
      'float a=cell*0.7+edge*0.6;' +
      'gl_FragColor=vec4(col,a*0.9);}';
    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return o; }
    var prog = gl.createProgram();
    gl.attachShader(prog, sh(gl.VERTEX_SHADER, VS));
    gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FS));
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { cv.style.display = 'none'; return; }
    gl.useProgram(prog);
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'a');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var uRes = gl.getUniformLocation(prog, 'u_res'), uTime = gl.getUniformLocation(prog, 'u_time'),
        uCell = gl.getUniformLocation(prog, 'u_cell'), uSoft = gl.getUniformLocation(prog, 'u_soft');
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    function applyColors() {
      var cell = tokenRGB('--gg-acid', '#c2ff3d'), soft = tokenRGB('--gg-acid-soft', '#dcff8b');
      gl.uniform3f(uCell, cell[0], cell[1], cell[2]);
      gl.uniform3f(uSoft, soft[0], soft[1], soft[2]);
    }
    applyColors();
    document.addEventListener('gg:themechange', function () { applyColors(); if (reduce) drawOnce(); });
    function resize() {
      var W = Math.max(1, Math.floor(cv.clientWidth * dpr)), H = Math.max(1, Math.floor(cv.clientHeight * dpr));
      if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; gl.viewport(0, 0, W, H); }
    }
    var t0 = null, raf = null, visible = true, lastDraw = 0;
    function drawOnce() { resize(); gl.uniform2f(uRes, cv.width, cv.height); gl.uniform1f(uTime, 0); gl.drawArrays(gl.TRIANGLES, 0, 3); }
    function frame(ts) {
      raf = null;
      if (t0 === null) t0 = ts;
      // throttle the GPU draw to ~30fps — keeps the effect but halves the load so clicks/scroll stay snappy
      if (ts - lastDraw >= 32) {
        lastDraw = ts;
        resize();
        gl.uniform2f(uRes, cv.width, cv.height);
        gl.uniform1f(uTime, (ts - t0) / 1000);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      }
      if (!reduce && visible) raf = requestAnimationFrame(frame);
    }
    function start() { if (reduce) { drawOnce(); return; } if (raf === null) raf = requestAnimationFrame(frame); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) start(); }, { threshold: 0 }).observe(cv);
    }
    start();
  }

  // Sticky mobile add-to-cart: mirrors the main price + button, delegates the
  // click to the real add-to-cart button (reusing AJAX add + drawer), and slides
  // up once the main buy row scrolls out of view.
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar || bar.dataset._init) return;
    var form = document.querySelector('.gg-pdp__form');
    var mainBtn = form && form.querySelector('[data-cart-add]');
    var buyRow = form && form.querySelector('.gg-pdp__buy');
    if (!form || !mainBtn || !buyRow) return;
    bar.dataset._init = '1';
    bar.hidden = false;

    var mainPrice = document.querySelector('.gg-pdp__info [data-price-now]');
    var stickyBtn = bar.querySelector('[data-sticky-add]');
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var stickyLabel = stickyBtn && stickyBtn.querySelector('span');

    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click(); // reuse the real add-to-cart flow (AJAX + open drawer)
    });

    function syncPrice() { if (mainPrice && stickyPrice) stickyPrice.textContent = mainPrice.textContent; }
    function syncBtn() {
      stickyBtn.disabled = mainBtn.disabled;
      if (stickyLabel) stickyLabel.textContent = (mainBtn.textContent || '').trim() || 'Add to cart';
    }
    syncPrice(); syncBtn();
    if ('MutationObserver' in window) {
      if (mainPrice) new MutationObserver(syncPrice).observe(mainPrice, { childList: true, characterData: true, subtree: true });
      new MutationObserver(syncBtn).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // show only once the buy row has scrolled UP past the top of the viewport,
        // not while it's still below the fold at the top of the page
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        // pad the page end so the fixed bar never covers the footer's last rows
        document.body.classList.toggle('gg-has-stickybar', show);
      }, { threshold: 0 }).observe(buyRow);
    } else { bar.classList.add('is-visible'); document.body.classList.add('gg-has-stickybar'); }
  }

  // Build-Your-Own Clinic Kit: quantity steppers + combined-MOQ gate, then one
  // customization form. Each selected product becomes its own cart line (shared Kit ID);
  // the logo file attaches to the first line via a NATIVE multipart submit, the rest are
  // AJAX-added first. Native cart + checkout, no app.
  function initKitBuilder() {
    var root = document.querySelector('[data-kit]');
    if (!root || root.dataset._init) return;
    root.dataset._init = '1';
    var moq = parseInt(root.getAttribute('data-kit-moq') || '100', 10);
    var STEP = Math.max(1, parseInt(root.getAttribute('data-kit-step') || '10', 10));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kit-card]'));
    var listEl = root.querySelector('[data-kit-list]');
    var emptyEl = root.querySelector('[data-kit-empty]');
    var totalEl = root.querySelector('[data-kit-total]');
    var fillEl = root.querySelector('[data-kit-fill]');
    var estEl = root.querySelector('[data-kit-est]');
    var minEl = root.querySelector('[data-kit-min]');
    var minTextEl = root.querySelector('[data-kit-mintext]');
    var contBtn = root.querySelector('[data-kit-continue]');
    var addBtns = Array.prototype.slice.call(root.querySelectorAll('[data-kit-add]'));
    var step1 = root.querySelector('[data-kit-step1]');
    var step2 = root.querySelector('[data-kit-step2]');
    var backBtn = root.querySelector('[data-kit-back]');
    var chosenEl = root.querySelector('[data-kit-chosen]');
    var form = root.querySelector('[data-kit-form]');
    if (!cards.length || !form) return;
    var formId = form.querySelector('[data-kit-form-id]');
    var formQty = form.querySelector('[data-kit-form-qty]');
    var formKitId = form.querySelector('[data-kit-form-kitid]');
    var formContents = form.querySelector('[data-kit-form-contents]');
    var submitBtn = form.querySelector('[data-kit-submit]');

    var lines = []; // each: { id, name, label, price(paise), qty }
    var kitFocusHint = null; // which line stepper to re-focus after a renderList rebuild

    function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function money(paise) { return 'Rs. ' + (Math.round(paise) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function total() { var t = 0; for (var i = 0; i < lines.length; i++) t += lines[i].qty; return t; }
    function estimate() { var c = 0; for (var i = 0; i < lines.length; i++) c += lines[i].qty * lines[i].price; return c; }
    function findLine(id) { for (var i = 0; i < lines.length; i++) if (lines[i].id === id) return lines[i]; return null; }

    function variantsOf(card) { try { return JSON.parse(card.getAttribute('data-variants')) || []; } catch (e) { return []; } }
    function resolveVariant(card) {
      var vs = variantsOf(card);
      var sels = Array.prototype.slice.call(card.querySelectorAll('[data-kit-opt]'));
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i], ok = true;
        for (var j = 0; j < sels.length; j++) {
          var pos = sels[j].getAttribute('data-kit-opt');
          if (String(v['o' + pos]) !== String(sels[j].value)) { ok = false; break; }
        }
        if (ok) return v;
      }
      return vs[0] || null;
    }
    function labelFor(v) { return (v && v.label && v.label !== 'Default Title') ? v.label : ''; }

    function refreshCardPrices() {
      cards.forEach(function (card) {
        var v = resolveVariant(card), el = card.querySelector('[data-kit-cardprice]');
        if (el && v) el.textContent = money(v.price);
      });
    }

    function renderList() {
      if (!listEl) return;
      listEl.innerHTML = lines.map(function (l) {
        var lbl = l.label ? ' <em>' + esc(l.label) + '</em>' : '';
        return '<div class="gg-kit__line" data-kit-line="' + l.id + '">' +
          '<span class="gg-kit__linename">' + esc(l.name) + lbl + '</span>' +
          '<span class="gg-kit__lineqty">' +
            '<button type="button" data-kit-line-dec aria-label="Remove ' + STEP + '">&minus;</button>' +
            '<b>' + l.qty + '</b>' +
            '<button type="button" data-kit-line-inc aria-label="Add ' + STEP + '">+</button>' +
          '</span>' +
          '<span class="gg-kit__lineprice">' + money(l.qty * l.price) + '</span>' +
          '<button type="button" class="gg-kit__lineremove" data-kit-line-remove aria-label="Remove item">&times;</button>' +
        '</div>';
      }).join('');
      var full = false; // kit total may exceed the minimum — clinics can order larger runs
      listEl.querySelectorAll('[data-kit-line]').forEach(function (row) {
        var id = parseInt(row.getAttribute('data-kit-line'), 10);
        var dec = row.querySelector('[data-kit-line-dec]');
        var inc = row.querySelector('[data-kit-line-inc]');
        var rm = row.querySelector('[data-kit-line-remove]');
        if (inc) inc.disabled = full;
        if (dec) dec.addEventListener('click', function () { kitFocusHint = { id: id, sel: '[data-kit-line-dec]' }; changeLine(id, -STEP); });
        if (inc) inc.addEventListener('click', function () { kitFocusHint = { id: id, sel: '[data-kit-line-inc]' }; changeLine(id, STEP); });
        if (rm) rm.addEventListener('click', function () { removeLine(id); });
      });
      // restore keyboard focus onto the stepper that triggered this rebuild (WCAG 2.4.3)
      if (kitFocusHint) {
        var _kr = listEl.querySelector('[data-kit-line="' + kitFocusHint.id + '"]');
        var _kb = _kr && _kr.querySelector(kitFocusHint.sel);
        if (_kb && !_kb.disabled) { try { _kb.focus(); } catch (e) {} }
        kitFocusHint = null;
      }
    }

    function changeLine(id, delta) {
      var l = findLine(id); if (!l) return;
      l.qty += delta;
      if (l.qty <= 0) { removeLine(id); return; }
      refresh();
    }
    function removeLine(id) { for (var i = 0; i < lines.length; i++) { if (lines[i].id === id) { lines.splice(i, 1); break; } } refresh(); }

    function addFromCard(card) {
      var v = resolveVariant(card);
      if (!v || v.available === false) return;
      var l = findLine(v.id);
      if (l) l.qty += STEP;
      else lines.push({ id: v.id, name: card.getAttribute('data-name'), label: labelFor(v), price: v.price, qty: STEP });
      refresh();
    }

    function refresh() {
      renderList();
      var t = total(), ready = (t >= moq);
      if (totalEl) totalEl.textContent = t;
      if (estEl) estEl.textContent = money(estimate());
      if (fillEl) fillEl.style.width = Math.min(100, Math.round(t * 100 / moq)) + '%';
      if (emptyEl) emptyEl.hidden = lines.length > 0;
      if (contBtn) contBtn.disabled = !ready;
      if (minEl) minEl.classList.toggle('is-ok', ready);
      if (minTextEl) {
        if (t === 0) minTextEl.textContent = 'Minimum kit size: ' + moq + ' units (added in packs of ' + STEP + ').';
        else if (t < moq) minTextEl.textContent = 'Add ' + (moq - t) + ' more units to reach the ' + moq + '-unit minimum.';
        else minTextEl.textContent = 'Kit ready — ' + t + ' units. Add more in packs of ' + STEP + ' for a larger order.';
      }
      // adding more is always allowed (multiples of the minimum)
    }

    cards.forEach(function (card) {
      var add = card.querySelector('[data-kit-add]');
      if (add) add.addEventListener('click', function () { addFromCard(card); });
      card.querySelectorAll('[data-kit-opt]').forEach(function (sel) { sel.addEventListener('change', refreshCardPrices); });
    });
    refreshCardPrices();
    refresh();

    if (contBtn) contBtn.addEventListener('click', function () {
      if (total() < moq || !lines.length) return;
      if (chosenEl) chosenEl.innerHTML = '<div class="gg-kit__chosenhead">Your kit — ' + total() + ' units</div>' +
        lines.map(function (l) { return '<div class="gg-kit__chosenrow"><span>' + esc(l.name) + (l.label ? ' — ' + esc(l.label) : '') + '</span><b>&times; ' + l.qty + '</b></div>'; }).join('');
      if (formContents) formContents.value = lines.map(function (l) { return l.name + (l.label ? ' (' + l.label + ')' : '') + ' x' + l.qty; }).join(' | ');
      if (formKitId) formKitId.value = 'KIT-' + Date.now().toString(36).toUpperCase();
      if (step1) step1.hidden = true;
      if (step2) { step2.hidden = false; step2.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
    });

    if (backBtn) backBtn.addEventListener('click', function () {
      if (step2) step2.hidden = true;
      if (step1) { step1.hidden = false; step1.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
    });

    form.addEventListener('submit', function (e) {
      if (!lines.length) { e.preventDefault(); return; }
      var first = lines[0];
      formId.value = first.id;
      formQty.value = first.qty;
      if (lines.length === 1) return; // single line: native submit handles it (logo attaches)

      // multiple lines: AJAX-add the rest (shared branding props), then native-submit the first + logo file
      e.preventDefault();
      if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = '<i class="ph ph-circle-notch"></i> Adding kit…'; }
      var shared = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (f) {
        if (f.type === 'file' || f.disabled) return;
        var key = f.name.slice(11, -1);
        if (f.value) shared[key] = f.value;
      });
      var rest = lines.slice(1).map(function (l) {
        var props = {}; for (var k in shared) props[k] = shared[k];
        props['Logo'] = 'See first kit item (' + first.name + ')';
        return { id: l.id, quantity: l.qty, properties: props };
      });
      // Remove any lines already in the cart for THIS kit (matched on the unique
      // Kit id every line carries) before re-adding, so a partial-failure retry
      // or a bfcache return can't double the kit. Same guard as the studio.
      var kitId = formKitId ? formKitId.value : '';
      function removePriorKitLines() {
        if (!kitId) return Promise.resolve();
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('cart read failed'); return r.json(); })
          .then(function (cart) {
            var keys = (cart.items || []).filter(function (it) { return it.properties && it.properties['Kit'] === kitId; }).map(function (it) { return it.key; });
            return keys.reduce(function (p, key) {
              return p.then(function () { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }); });
            }, Promise.resolve());
          });
      }
      // one request per line — batch multi-item adds get wrongly capped at 50/line
      removePriorKitLines()
        .then(function () {
          return rest.reduce(function (p, it) {
            return p.then(function () {
              return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(it) })
                .then(function (r) { if (!r.ok) throw new Error('add failed'); });
            });
          }, Promise.resolve());
        })
        .then(function () { form.submit(); })
        .catch(function () {
          removePriorKitLines().catch(function () {}); // roll back partial adds
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = '<i class="gg-cart-ic"></i> Add kit to cart'; }
          alert('Something went wrong adding your kit — please try again.');
        });
    });
  }

  // Exhibition galleries: autoplay + arrows + dots + swipe. Pauses on hover and
  // when offscreen; respects reduced-motion. Transform-based (GPU), minimal JS.
  function initExhibitions() {
    document.querySelectorAll('[data-exhib-gallery]').forEach(function (g) {
      if (g.dataset._init) return; g.dataset._init = '1';
      var track = g.querySelector('[data-exhib-track]');
      var slides = g.querySelectorAll('.gg-exhib__slide');
      var prev = g.querySelector('[data-exhib-prev]');
      var next = g.querySelector('[data-exhib-next]');
      var dotsWrap = g.querySelector('[data-exhib-dots]');
      var n = slides.length, i = 0, timer = null;
      if (n <= 1) { if (prev) prev.hidden = true; if (next) next.hidden = true; if (dotsWrap) dotsWrap.hidden = true; return; }
      var dots = [];
      for (var k = 0; k < n; k++) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'gg-exhib__dot'; d.setAttribute('aria-label', 'Go to image ' + (k + 1));
        (function (idx) { d.addEventListener('click', function () { go(idx); restart(); }); })(k);
        dotsWrap.appendChild(d); dots.push(d);
      }
      function go(to) {
        i = (to + n) % n;
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      var speed = parseInt(g.getAttribute('data-autoplay') || '0', 10);
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { if (!speed || reduce) return; stop(); timer = setInterval(function () { go(i + 1); }, speed); }
      function restart() { stop(); start(); }
      if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
      var x0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
        x0 = null; start();
      }, { passive: true });
      g.addEventListener('mouseenter', stop);
      g.addEventListener('mouseleave', start);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es[0].isIntersecting ? start() : stop(); }, { threshold: 0.2 }).observe(g);
      } else { start(); }
      go(0);
    });
  }

  // Events: clickable year filter — show only events matching the chosen year.
  function initExhibFilter() {
    document.querySelectorAll('[data-exhib-filter]').forEach(function (bar) {
      if (bar.dataset._init) return; bar.dataset._init = '1';
      var section = bar.closest('.gg-exhib');
      if (!section) return;
      var items = section.querySelectorAll('[data-year]');
      var upcoming = section.querySelector('.gg-exhib__upcoming');
      var empty = section.querySelector('[data-exhib-empty]');
      function apply(year) {
        var shown = 0;
        items.forEach(function (el) {
          var match = year === 'all' || el.getAttribute('data-year') === year;
          el.hidden = !match;
          if (match) shown++;
        });
        if (upcoming) {
          var anyRow = Array.prototype.some.call(upcoming.querySelectorAll('.gg-exhib__row'), function (r) { return !r.hidden; });
          upcoming.hidden = !anyRow;
        }
        if (empty) empty.hidden = shown > 0;
      }
      section.addEventListener('click', function (e) {
        var chip = e.target.closest('.gg-exhib__chip');
        if (!chip) return;
        var year = chip.getAttribute('data-year');
        bar.querySelectorAll('.gg-exhib__chip').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-year') === year); });
        apply(year);
      });
    });
  }

  // Events: "See stall details" accordion — opens on hover (CSS) and pins open on click.
  function initExhibAcc() {
    document.querySelectorAll('[data-exhib-acc-btn]').forEach(function (btn) {
      if (btn.dataset._init) return; btn.dataset._init = '1';
      var row = btn.closest('[data-exhib-acc]');
      if (!row) return;
      btn.addEventListener('click', function () {
        var open = row.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  // Collections accordion — single-open; refresh carousel arrow states when a row opens.
  function initCollacc() {
    document.querySelectorAll('[data-collacc]').forEach(function (list) {
      var items = [].slice.call(list.querySelectorAll('details'));
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });   // single-open accordion
          requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); }); // recalc carousel arrows
        });
      });
    });
  }

  // Product spotlight slider — scroll-snap track, dots + arrows, optional auto-rotate.
  function initSpotSlider() {
    document.querySelectorAll('[data-spotslider]').forEach(function (root) {
      var track = root.querySelector('[data-spot-track]');
      if (!track) return;
      var slides = track.children;
      if (slides.length < 2) return;
      var dots = [].slice.call(root.querySelectorAll('[data-spot-dot]'));
      var prev = root.querySelector('[data-spot-prev]');
      var next = root.querySelector('[data-spot-next]');
      function current() { return Math.round(track.scrollLeft / track.clientWidth); }
      function goto(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
      function setActive() { var c = current(); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); }); }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goto(i); }); });
      if (prev) prev.addEventListener('click', function () { goto(current() - 1); });
      if (next) next.addEventListener('click', function () { goto(current() + 1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(setActive); }, { passive: true });
      var secs = parseInt(root.getAttribute('data-spot-autoplay') || '0', 10), timer = null;
      function play() { if (secs > 0 && !timer) timer = setInterval(function () { var c = current(); goto(c >= slides.length - 1 ? 0 : c + 1); }, secs * 1000); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if (secs > 0) { play(); root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play); }
      setActive();
    });
  }

  // Spotlight "full product" mode — variant dropdown updates the add-to-cart id + price.
  function initSpotVariant() {
    document.querySelectorAll('[data-spot-variant]').forEach(function (sel) {
      var scope = sel.closest('[data-spot-form]');
      if (!scope) return;
      var idInput = scope.querySelector('[data-spot-variant-id]');
      var priceEl = scope.querySelector('[data-spot-price]');
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (idInput) idInput.value = sel.value;
        var p = opt.getAttribute('data-price');
        if (priceEl && p) priceEl.textContent = p;
      });
    });
  }

  // The ≤749px hero sizes itself as calc(100svh - var(--gg-hero-offset)); the
  // variable was never defined (only the 247px fallback applied). Measure the
  // real announce-bar + header height and publish it so the hero fits exactly.
  function initHeroOffset() {
    var announce = document.querySelector('.gg-announce');
    var header = document.querySelector('.gg-site-header');
    if (!header) return;
    function setOffset() {
      var off = (announce ? announce.offsetHeight : 0) + header.offsetHeight;
      if (off > 0) document.documentElement.style.setProperty('--gg-hero-offset', off + 'px');
    }
    setOffset();
    window.addEventListener('resize', setOffset, { passive: true });
    if ('ResizeObserver' in window) { try { new ResizeObserver(setOffset).observe(header); } catch (e) {} }
  }

  function boot() {
    // In the theme editor, never hide content for scroll-animation — otherwise a
    // section re-render (on any setting change) leaves it blank until refresh.
    if (window.Shopify && window.Shopify.designMode) {
      document.documentElement.classList.remove('gg-js');
    }
    autoReveal();
    initReveal();
    initThemeToggle();
    initAccountFeedback();
    initMobileSearch();
    initCellsBg();
    initDrawer();
    initHeroOffset();
    initStickyHeader();
    initMegaTabs();
    initCompare();
    initHero();
    initCarousel();
    initSearchSuggest();
    initCartDrawer();
    initProductForm();
    initStickyAtc();
    initExhibitions();
    initExhibFilter();
    initExhibAcc();
    initMegaFeat();
    initMegaBackdrop();
    initHmegaClick();
    initArticleMedia();
    initPdpCustomizer();
    initKitBuilder();
    initCatbar();
    initPromoPopup();
    initCollacc();
    initSpotSlider();
    initSpotVariant();
    initWishlist();
  }

  // Wishlist — saved in the browser (device-local). Heart on cards + product page,
  // a header counter, and the wishlist page rendered from the saved list.
  function initWishlist() {
    if (window.__ggWishInit) { ggWishSync(); ggWishRender(); return; }
    window.__ggWishInit = true;
    var KEY = 'gg_wishlist';
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    window.ggWishGet = function () { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
    function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} ggWishCount(list); }
    function ggWishCount(list) {
      list = list || ggWishGet();
      document.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = list.length; el.hidden = list.length === 0; });
    }
    window.ggWishSync = function () {
      var list = ggWishGet();
      document.querySelectorAll('[data-wish]').forEach(function (b) {
        var on = list.some(function (i) { return i.handle === b.getAttribute('data-handle'); });
        b.classList.toggle('is-saved', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
      });
    };
    window.ggWishRender = function () {
      var grid = document.querySelector('[data-wishlist-grid]');
      if (!grid) return;
      var empty = document.querySelector('[data-wishlist-empty]');
      var list = ggWishGet();
      if (!list.length) { grid.hidden = true; grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
      if (empty) empty.hidden = true;
      grid.hidden = false;
      grid.innerHTML = list.map(function (i) {
        var img = i.img ? '<img src="' + esc(i.img) + '" alt="" loading="lazy">' : '<i class="ph ph-package" aria-hidden="true"></i>';
        return '<div class="gg-wishcard">' +
          '<a class="gg-wishcard__media" href="' + esc(i.url) + '">' + img + '</a>' +
          '<button type="button" class="gg-wishcard__remove" data-wish-remove="' + esc(i.handle) + '" aria-label="Remove ' + esc(i.title) + '"><i class="ph ph-x" aria-hidden="true"></i></button>' +
          '<div class="gg-wishcard__body">' +
          '<a class="gg-wishcard__name" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
          (i.price ? '<div class="gg-wishcard__price">' + esc(i.price) + '</div>' : '') +
          '<a class="gg-btn gg-btn--sm gg-btn--soft gg-btn--full" href="' + esc(i.url) + '">View product</a>' +
          '</div></div>';
      }).join('');
    };
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-wish]');
      if (toggle) {
        e.preventDefault();
        var list = ggWishGet();
        var h = toggle.getAttribute('data-handle');
        if (list.some(function (i) { return i.handle === h; })) {
          list = list.filter(function (i) { return i.handle !== h; });
        } else {
          list.push({ handle: h, url: toggle.getAttribute('data-url'), title: toggle.getAttribute('data-title'), img: toggle.getAttribute('data-img'), price: toggle.getAttribute('data-price') });
        }
        save(list); ggWishSync(); ggWishRender();
        return;
      }
      var rm = e.target.closest('[data-wish-remove]');
      if (rm) {
        var handle = rm.getAttribute('data-wish-remove');
        var l = ggWishGet().filter(function (i) { return i.handle !== handle; });
        save(l); ggWishSync(); ggWishRender();
      }
    });
    ggWishCount(); ggWishSync(); ggWishRender();
  }

  // Reveal every animated element inside a scope immediately (no observer wait).
  function revealIn(scope) {
    (scope || document).querySelectorAll('.gg-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  // Shopify theme editor: when a section is added, duplicated, or reloaded its
  // markup is injected after load — so re-tag reveals (and re-init widgets) and
  // make them visible immediately, otherwise they'd stay at opacity:0 ("glitch").
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      autoReveal();
      revealIn(e.target);
      initMegaTabs(); initCompare(); initHero(); initCarousel(); initSearchSuggest();
      initStickyHeader(); initProductForm(); initStickyAtc(); initKitBuilder(); initExhibitions(); initExhibFilter(); initExhibAcc();
    });
    document.addEventListener('shopify:section:select', function (e) { revealIn(e.target); });
    document.addEventListener('shopify:block:select', function (e) { revealIn(e.target); });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
